import is from 'is_js';
import swal from 'sweetalert2';
import axios from 'axios';

let queue = [];
let blockQueue = false;
export const global = {
	// Ends the loading screen on the current page
	// @arg type[String] - The type of the toast
	// @arg msg[String] - The displayed message
	showToast: function(type, msg) {
		if (!blockQueue) {
			blockQueue = true;
			window.setTimeout(() => {
				// Remove all similar msgs from queue
				queue = queue.filter((pair) => pair[1] != msg);
				swal.mixin({
					toast: true,
					position: 'top-end',
					showConfirmButton: false,
					timer: 2500,
					timerProgressBar: true,
					didOpen: (toast) => {
						toast.addEventListener('mouseenter', swal.stopTimer);
						toast.addEventListener('mouseleave', swal.resumeTimer);
						toast.addEventListener('mouseup', swal.close);
					},
				}).fire({
					icon: type,
					title: msg,
				});
				window.setTimeout(() => {
					blockQueue = false;
				}, 2500);
			}, 100);
		} else {
			queue.push([type, msg]);
			let timeout = window.setInterval(() => {
				if (!blockQueue) {
					clearTimeout(timeout);

					let toast = queue.shift();
					if (toast) this.showToast(toast[0], toast[1]);
				}
			}, 100);
		}
	},
	isMobile() {
		if (is.mobile()) return true;
		else return false;
	},
	getHyphenation: function(translations, cb) {
		axios
			.post('/landingAPI/hyphenate/hyphenateText', { translations: translations })
			.then((res) => {
				cb(res.data);
			})
			.catch((err) => {
				return err;
			});
	},
};
